class PushCartAccordion extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)

    this.listeners.add(this, 'click', this.handleTrigger)
  }

  handleTrigger (event) {
    const clickedTriggerEl = event.target.closest(this.els?.trigger?.selector)
    if (!clickedTriggerEl) return

    this.els.trigger.elements.forEach((triggerEl) => {
      if (triggerEl === clickedTriggerEl) {
        if (triggerEl.classList.contains('psh-Discount_Title-open')) {
          triggerEl.classList.remove('psh-Discount_Title-open')
        } else {
          triggerEl.classList.add('psh-Discount_Title-open')
        }
      } else if (this.dataset.type === 'oneopen') {
        triggerEl.classList.remove('psh-Discount_Title-open')
      }
    })

    this.els.content.elements.forEach((contentEl) => {
      if (contentEl.id === clickedTriggerEl.getAttribute('aria-controls')) {
        if (contentEl.classList.contains('psh-Discount_Expand-open')) {
          contentEl.classList.remove('psh-Discount_Expand-open')
        } else {
          contentEl.classList.add('psh-Discount_Expand-open')

          contentEl.addEventListener(
            'transitionend',
            () => {
              const cartDrawer = document.querySelector(
                '#push-cart .drw-Drawer_Inner',
              )

              cartDrawer?.scrollTo({
                top: cartDrawer.scrollHeight,
                behavior: 'smooth',
              })
            },
            { once: true },
          )
        }
      } else if (this.dataset.type === 'oneopen') {
        contentEl.classList.remove('psh-Discount_Expand-open')
      }
    })
  }
}

if (!customElements.get('discount-accordion')) {
  customElements.define('discount-accordion', PushCartAccordion)
}
